import { UsernameAttributes } from "aws-amplify-react";
import React from "react";
import { AgeReadyContext } from "./AgeReadyContext/AgeReadyContext";
import App from "./App";
import AgeReadyAuthenticator from "./Components/Authenticator/AgeReadyAuthenticator";
import Bootstrap from "./Components/Authenticator/AuthenticatorTheme";
import SignUpConfig from "./Components/Authenticator/SignUpConfig";

const AppWithAuth: React.FC = (): React.ReactElement => {
  return (
    <>
      <div style={{ minHeight: "100vh" }} data-testid="app">
        <AgeReadyAuthenticator
          usernameAttributes={UsernameAttributes.EMAIL}
          theme={Bootstrap}
          signUpConfig={SignUpConfig}
        >
          <AgeReadyContext>
            <App />
          </AgeReadyContext>
        </AgeReadyAuthenticator>
      </div>
    </>
  );
};

export default AppWithAuth;
